import MainContainer from "../../layout/MainContainer";
import TableComponent from "../../components/TableComponent";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import SearchBar from "../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";
import AddSubCategory from "../../Modals/addSubCategory";
import {
  useAddCategoryMutation,
  useDeleteCategoryMutation,
  useLazyGetCategoryQuery,
  useUpdateCategoryMutation,
} from "../../services/categories";
import moment from "moment";
import { showError, showToast } from "../../constants/toasts";
import AddCategory from "../../Modals/addCategory";
import { isValidInput } from "../../utils/validations";
import { ConfirmationModal } from "../../Modals/ConfirmationModal";
import CustomToggle from "../../helpers/CustomToggle";

const SubcategoryPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();

  const [fetchCategories, { isLoading }] = useLazyGetCategoryQuery();
  const [addCategory, { isLoading: addLoading }] = useAddCategoryMutation();
  const [updateStatus] = useUpdateCategoryMutation();
  const [deletecategory] = useDeleteCategoryMutation();

  const [confirmation, setConfirmation] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [categoriesList, setCategoriesList] = useState([]);

  const onPageChange = (_: any, newPage: number) => {
    setPage(newPage);
  };

  const columns: GridColDef<(typeof categoriesList)[number]>[] = [
    {
      flex: 2,
      minWidth: 220,
      field: "name",
      headerName: "Sub Category Name",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 180,
      field: "date",
      headerName: "Created Date",
      editable: false,
      sortable: false,
      renderCell: (_: any) => {
        return (
          <Typography>{moment(_?.createdAt).format("DD MMMM YYYY")}</Typography>
        );
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }: any) => {
        return (
          <CustomToggle
            checked={!row?.isBlocked}
            onChange={() => handleStatusUpdate(row?._id, !row?.isBlocked)}
            id={row?._id}
          />
        );
      },
    },
    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton
                onClick={() => {
                  setSelectedId(row?._id);
                  setCategoryName(row?.name || "");
                  setEdit(true);
                  setOpen(true);
                }}
              >
                <img src="/static/images/edit2_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton
                onClick={() => {
                  setSelectedId(row?._id);
                  setConfirmation(true);
                }}
              >
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleDelete = async () => {
    try {
      const response = await deletecategory({ id: selectedId }).unwrap();
      if (response?.statusCode === 200) {
        showToast("Deleted Successfully");
        getCategories();
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const handleStatusUpdate = async (id: string, status: boolean) => {
    const body = {
      isBlocked: status,
    };

    try {
      const response = await updateStatus({ body, id }).unwrap();
      if (response?.statusCode === 200) {
        showToast(
          `Sub Catogery ${!status ? "activated" : "deactivated"} successfully`
        );
        getCategories();
      } else {
        showError("Please try again");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const handleSubmit = async (name: string) => {
    if (!name?.length) {
      showError("Please input catgory name");
      return;
    }
    try {
      let response = {} as any;
      if (edit) {
        response = await updateStatus({
          body: {
            name,
          },
          id: selectedId,
        } as any).unwrap();
      } else {
        response = await addCategory({
          name,
          parentId: id,
          categoryType: "STORAGE",
        }).unwrap();
      }
      if (response?.statusCode === 200) {
        setOpen(false);
        setCategoryName("");
        setEdit(false);
        getCategories();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      console.log(error);
    }
  };

  const getCategories = async () => {
    try {
      const response = await fetchCategories({
        page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
        parentId: id,
        categoryType: "STORAGE",
      }).unwrap();
      if (response?.statusCode === 200) {
        setCategoriesList((response?.data?.data || []) as any);
        setTotalCount(response?.data?.total);
      } else {
        setCategoriesList([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getCategories();
  }, [debouncedSearchTerm, page]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Sub-Categories</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
          <span onClick={() => navigate(-1)}> Manage Categories</span> -
          Sub-Categories
        </p>
      </div>
      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                placeholder="Search..."
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
          </div>
          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => setOpen(true)}>
              <AddIcon /> Add
            </Button>
          </div>
        </div>
        <div className="sorting_table">
          <TableComponent
            count={totalCount}
            onPageChange={onPageChange}
            loading={isLoading}
            page={page}
            columns={columns || []}
            rows={categoriesList || []}
          />
        </div>
      </div>
      <AddCategory
        edit={edit}
        value={categoryName || ""}
        loading={addLoading}
        handleSubmit={handleSubmit}
        open={open}
        isSubCat={true}
        onClose={handleCloseModal}
        setOpen={setOpen}
      />

      <ConfirmationModal
        text={"Are you sure to delete this sub-category"}
        openModal={confirmation}
        setOpenModal={setConfirmation}
        handleSubmit={handleDelete}
      />
    </MainContainer>
  );
};

export default SubcategoryPage;
